
/* PERMISSION */
export const GET_PERMISSION_LISTING = "GET_PERMISSION_LISTING"
export const GET_PERMISSION_LISTING_SUCCESS = "GET_PERMISSION_LISTING_SUCCESS"
export const GET_PERMISSION_LISTING_FAIL = "GET_PERMISSION_LISTING_FAIL"

export const GET_PERMISSION_DETAILS = "GET_PERMISSION_DETAILS";
export const GET_PERMISSION_DETAILS_SUCCESS = "GET_PERMISSION_DETAILS_SUCCESS";
export const GET_PERMISSION_DETAILS_FAIL = "GET_PERMISSION_DETAILS_FAIL";

export const ADD_PERMISSION = "ADD_PERMISSION";
export const ADD_PERMISSION_SUCCESS = "ADD_PERMISSION_SUCCESS";
export const ADD_PERMISSION_FAIL = "ADD_PERMISSION_FAIL";

export const UPDATE_PERMISSION = "UPDATE_PERMISSION";
export const UPDATE_PERMISSION_SUCCESS = "UPDATE_PERMISSION_SUCCESS";
export const UPDATE_PERMISSION_FAIL = "UPDATE_PERMISSION_FAIL";

export const DELETE_PERMISSION = "DELETE_PERMISSION";
export const DELETE_PERMISSION_SUCCESS = "DELETE_PERMISSION_SUCCESS";
export const DELETE_PERMISSION_FAIL = "DELETE_PERMISSION_FAIL";

export const EXPORT_PERMISSION = "EXPORT_PERMISSION";
export const EXPORT_PERMISSION_SUCCESS = "EXPORT_PERMISSION_SUCCESS";
export const EXPORT_PERMISSION_FAIL = "EXPORT_PERMISSION_FAIL";

export const RESET_PERMISSION_STATE = 'RESET_PERMISSION_STATE';